import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Box,
    Alert,
} from '@mui/material';
import { customersApi } from 'src/api/endpoints/customers';

interface CreateBankModalProps {
    open: boolean;
    onClose: () => void;
    onSuccess: () => void;
    userId: string;
}

const CreateBankModal: React.FC<CreateBankModalProps> = ({
    open,
    onClose,
    onSuccess,
    userId,
}) => {
    const [accountNumber, setAccountNumber] = useState('');
    const [ifscCode, setIfscCode] = useState('');
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError(null);
        setLoading(true);

        try {
            const response = await customersApi.createBank(
                userId,
                accountNumber,
                ifscCode
            );
            if (response.status) {
                onSuccess();
                onClose();
                setAccountNumber('');
                setIfscCode('');
            } else {
                setError(response.message || 'Failed to add bank details');
            }
        } catch (err) {
            setError(err.message || "Error in Create Bank");
            console.error('Error adding bank details:', err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Add Bank Details</DialogTitle>
            <form onSubmit={handleSubmit}>
                <DialogContent>
                    {error && (
                        <Alert severity="error" sx={{ mb: 2 }}>
                            {error}
                        </Alert>
                    )}
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <TextField
                            label="Account Number"
                            value={accountNumber}
                            onChange={(e) => setAccountNumber(e.target.value)}
                            required
                            fullWidth
                        />
                        <TextField
                            label="IFSC Code"
                            value={ifscCode}
                            onChange={(e) => setIfscCode(e.target.value)}
                            required
                            fullWidth
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>Cancel</Button>
                    <Button
                        type="submit"
                        variant="contained"
                        disabled={loading}
                    >
                        {loading ? 'Adding...' : 'Add Bank Details'}
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};

export default CreateBankModal; 